import React, {useEffect, useState} from 'react';
import Topbar from "../layout/Topbar";
import Sidebar from "../layout/Sidebar";
import CampaignsGrid from "./CampaignsGrid";
import {Box, CssBaseline} from "@mui/material";
import {CampaignReportNavigation} from "./CampaignReportNavigation";
import {campaignActions} from "../../store/actions/campaignsAction";
import {compose} from "redux";
import {connect} from "react-redux";
import GroupBy2Grid from "./GroupBy2Grid";
import GroupBy3Grid from "./GroupBy3Grid";
import {groupBy1Action} from "../../store/actions/groupBy1Action";
import GroupBy1Grid from "./GroupBy1Grid";
import {CustomMainRootBox} from "../dashboard/Dashboard";
import {CustomTableContainer} from "../logs/LogClicksTable";
import {styled} from "@mui/system";
import TreeViewGrid from "./TreeViewGrid";

export const CustomCampaignDataGridBox = styled(Box)({
    flex: '1 1 0', minHeight: 0, minWidth: 0, width: '100%', position: 'relative'
});

export const DetailsCampaignDataGridBox = CustomCampaignDataGridBox;

function CampaignsView(props) {

    const {selectedRows, filterTrafficSources, detailsReportingView} = props.campaignsState;
    const [tabValue, setTabValue] = useState("campaigns");

    useEffect(() => {
        setTabValue(current => current === 'campaigns' ? current : detailsReportingView === 'tree' ? 'tree'
            : current === 'tree' ? 'groupBy1' : current);
    }, [detailsReportingView]);
    const optimizationSource = filterTrafficSources?.length === 1 ? filterTrafficSources[0]?.label : '';
    const groupDisabled = !selectedRows?.size && !optimizationSource;
    const reportOptions = [
        {value: 'campaigns', label: 'Campaigns', count: selectedRows?.size},
        ...(detailsReportingView === 'tree'
            ? [{value: 'tree', label: 'Reports', count: props.groupBy1State.selectedRows?.size, disabled: groupDisabled}]
            : [props.groupBy1State, props.groupBy2State, props.groupBy3State].map((group, index) => ({
                value: `groupBy${index + 1}`, label: group.groupBy.label, level: index + 1,
                count: group.selectedRows?.size, disabled: groupDisabled
            })))
    ];

    const activeTabValue = reportOptions.some(option => option.value === tabValue) ? tabValue : 'campaigns';

    const handleCampaignRowDoubleClick = (data) => {
        // block double-click on these columns
        if (data?.column?.key === "custom-select-row" || data?.column?.key === "mark") {
            return false;
        }

        if (detailsReportingView === "tree") {
            setTabValue("tree");
        } else {
            setTabValue("groupBy1");
        }
    };

    const handleGroupBy1RowDoubleClick = (data, column) => {
        // block double-click on these columns
        if (column?.key === "status" || column?.key === "bid" || column?.key === "select-row" || column?.key === "mark") {
            return false;
        }

        if (detailsReportingView === "tree") {
            setTabValue("tree");
        } else {
            setTabValue("groupBy2");
        }
    };

    const handleGroupBy2RowDoubleClick = (data, column) => {
        // block double-click on these columns
        if (column?.key === "status" || column?.key === "bid" || column?.key === "select-row" || column?.key === "mark") {
            return false;
        }

        if (detailsReportingView === "tree") {
            setTabValue("tree");
        } else {
            setTabValue("groupBy3");
        }
    };

    return (
        <CustomMainRootBox>
            <CssBaseline/>
            <Sidebar {...props}/>
            <Topbar/>
            <CustomTableContainer>
                <CampaignReportNavigation value={activeTabValue} onChange={setTabValue} options={reportOptions} optimizationSource={optimizationSource}
                    mode={detailsReportingView} onModeChange={mode => {setTabValue('campaigns'); props.updateDetailsReportingView(mode);}}/>
                {activeTabValue === "campaigns" &&
                    <CampaignsGrid
                        {...props}
                        handleDoubleClick={handleCampaignRowDoubleClick}
                        groupBy="campaign_id"
                        columnGroup="campaigns"
                        report="campaign"
                    />
                }
                {activeTabValue === "groupBy1" &&
                    <GroupBy1Grid
                        {...props}
                        handleDoubleClick={handleGroupBy1RowDoubleClick}
                        columnGroup="detailsReport"
                        report="detailsReport"
                    />
                }
                {activeTabValue === "groupBy2" &&
                    <GroupBy2Grid
                        {...props}
                        handleDoubleClick={handleGroupBy2RowDoubleClick}
                        columnGroup="detailsReport"
                        report="detailsReport"
                    />
                }
                {activeTabValue === "groupBy3" &&
                    <GroupBy3Grid
                        {...props}
                        columnGroup="detailsReport"
                        report="detailsReport"
                    />
                }
                {activeTabValue === "tree" &&
                    <TreeViewGrid
                        {...props}
                        handleDoubleClick={handleGroupBy1RowDoubleClick}
                        columnGroup="detailsReport"
                        report="detailsReport"
                    />
                }
            </CustomTableContainer>
        </CustomMainRootBox>
    );
}

const mapStateToProps = (state) => {
    return {
        campaignsState: state.campaign,
        groupBy1State: state.groupBy1,
        groupBy2State: state.groupBy2,
        groupBy3State: state.groupBy3,
    }
};

const actionCreators = {
    updateDetailsReportingView: campaignActions.updateDetailsReportingView,
    resetTrafficSource: groupBy1Action.resetTrafficSource,
    resetIntegration: groupBy1Action.resetIntegration,
};

export default compose(connect(mapStateToProps, actionCreators))(CampaignsView);
